const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function api(path, options = {}) {
  const res = await fetch(`${API}${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    ...options,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    const detail = typeof err.detail === "string" ? err.detail : "حدث خطأ غير متوقع";
    throw new Error(detail);
  }
  return res.json();
}

export async function apiUpload(path, formData) {
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    credentials: "include",
    body: formData,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    const detail = typeof err.detail === "string" ? err.detail : "فشل رفع الملف";
    throw new Error(detail);
  }
  return res.json();
}

export async function fetchImageUrl(path) {
  const res = await fetch(`${API}${path}`, { credentials: "include" });
  if (!res.ok) throw new Error("تعذر تحميل الصورة");
  return URL.createObjectURL(await res.blob());
}
